import api from '../api/axiosClient';
import { getMakeupArtists } from './makeupArtistService';

export interface ArtistSubscriptionPlanSummary {
  planId: number;
  planName: string;
  price: number;
  durationInDays: number;
  isActive: boolean;
  isDefault: boolean;
}

export interface ArtistSubscription {
  artistSubscriptionId: number;
  artistId: number;
  planId: number;
  isActive: boolean;
  activatedByAdmin: boolean;
  transactionId?: string;
  startDate: string;
  endDate: string;
  createdDate: string;
  plan?: ArtistSubscriptionPlanSummary;
  artistName?: string; // if backend provides
  artist?: any; // if backend provides full artist object
}

export interface AssignSubscriptionPayload {
  artistId: number;
  planId: number;
  transactionId?: string;
}

const BASE = '/admin/artist-subscription';
const ARTIST_BASE = '/Artist/subscription';

export const getArtistSubscriptions = async (): Promise<ArtistSubscription[]> => {
  const res = await api.get<ArtistSubscription[]>(BASE);
  const subscriptions = res.data;
  
  // If artistName is not provided by backend, fetch artist details
  if (subscriptions.length > 0 && !subscriptions[0].artistName && !subscriptions[0].artist) {
    try {
      const artists = await getMakeupArtists();
      // Use makeupArtistId for mapping, not id
      const artistMap = new Map(artists.map((a: any) => [a.makeupArtistId, a.displayName]));
      return subscriptions.map(sub => ({
        ...sub,
        artistName: String(artistMap.get(sub.artistId) || `Artist #${sub.artistId}`)
      }));
    } catch (error) {
      console.error('Failed to fetch artist names:', error);
      return subscriptions;
    }
  }
  
  // If backend provides artist object, extract displayName
  return subscriptions.map(sub => ({
    ...sub,
    artistName: String(sub.artistName || sub.artist?.displayName || `Artist #${sub.artistId}`)
  }));
};

export const assignPlanToArtist = async (data: AssignSubscriptionPayload): Promise<ArtistSubscription> => {
  const res = await api.post<ArtistSubscription>(`${BASE}/assign`, data);
  return res.data;
};

export const updateArtistSubscriptionStatus = async (id: number, action: 'renew' | 'deactivate'): Promise<ArtistSubscription> => {
  const res = await api.patch<ArtistSubscription>(`${BASE}/${id}/status`, { action });
  return res.data;
};

// Artist endpoint - get own subscription status
export const getArtistSubscriptionStatus = async (): Promise<ArtistSubscription> => {
  const res = await api.get<ArtistSubscription>(`${ARTIST_BASE}/status`);
  return res.data;
};
